import { render, staticRenderFns } from "./view-switcher.vue?vue&type=template&id=491e4c6d&scoped=true&"
import script from "./view-switcher.vue?vue&type=script&lang=js&"
export * from "./view-switcher.vue?vue&type=script&lang=js&"
import style0 from "./view-switcher.vue?vue&type=style&index=0&id=491e4c6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e4c6d",
  null
  
)

export default component.exports